import {jwtDecode} from 'jwt-decode';
import axios from 'axios';
import * as constants from './constants';

const AuthService = {

    // Initializing important variables

    login(username, password, client) {
    //login(username, password) {
        // Get a token from api server using the fetch api
        //return this.fetch(`${this.domain}/token`, {

        return this.fetch(constants.default.baseUrl + '/api/token/' + client, {
        //return this.fetch(constants.default.baseUrl + '/api/token/', {
            method: 'POST',
            body: {
                username: username,
                password: password,
                client: client
            }
        }).then(res => {
            this.setToken(res.data) // Setting the token in localStorage
            return Promise.resolve(res);
        })
    },

    forgotPassword(email, client) {
        //login(username, password) {
            // Get a token from api server using the fetch api
            //return this.fetch(`${this.domain}/token`, {
   
                return axios({
                    method: 'post',
                    url: constants.default.baseUrl + '/api/user/GeneratePasswordTokenAndSendEmailAsync/' + client,
                    data: {
                        email: email,
                        client: client
                    },
                    headers: { Authorization: `Bearer ${AuthService.getToken()}` } 
                })

        },

    getPermissions() {
        var roles = this.getRoles();
        if (roles) {
            if(Array.isArray(roles)) {
                var a = this.getRoles().map(subject => {
                    var actions = this.getRoleClaims(subject);
                    if (actions) {
                        return {actions, subject}
                    } 
                })

                return a;
            }
           else
           {
                var subject = this.getRoles();
                var actions = this.getRoleClaims(subject);
                if (actions) {
                    return [{actions, subject}]
                } 
           }
            
        }
    },
    
    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken() // GEtting token from localstorage
        return !!token && !this.isTokenExpired(token) // handwaiving here
    },

    isTokenExpired(token) {
        try {
            const decoded = jwtDecode(token);
            if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    },

    getRoleClaims(role) {
        try {
            const token = this.getToken();
            const decoded = jwtDecode(token);
            if (decoded) {
                var claim = decoded['role_' + role + '_claim'];
                if (claim){
                    var arr = claim.split(',');
                    return arr;
                }
                return false;
            }
        }
        catch (err) {
            return false;
        }
    },

    getRoles() {
        try {
            const token = this.getToken();
            const decoded = jwtDecode(token);
            if (decoded) {
                return decoded.roles;
            }
        }
        catch (err) {
            return false;
        }
    }, 

    getUserName() {
        try {
            const token = this.getToken();
            const decoded = jwtDecode(token);
            if (decoded) {
                return decoded.sub;
            }
        }
        catch (err) {
            return false;
        }
    },

    // CHECKPOINT-75: client-side gate for the admin password buttons. The real
    // enforcement lives server-side (UserController.IsInRoleAsync); this just
    // hides the UI from non-admins.
    isAdmin() {
        var roles = this.getRoles();
        if (!roles) return false;
        if (Array.isArray(roles)) {
            return roles.some(r => String(r).toLowerCase() === 'admin');
        }
        return String(roles).toLowerCase() === 'admin';
    },

    // CHECKPOINT-75: true when the current token carries the forced-change flag.
    mustChangePassword() {
        try {
            const token = this.getToken();
            if (!token) return false;
            const decoded = jwtDecode(token);
            return !!decoded && decoded.must_change_password === 'true';
        }
        catch (err) {
            return false;
        }
    },

    getClient() {
        try {
            const token = this.getToken();
            const decoded = jwtDecode(token);
            if (decoded) {
                return decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/system'];
            }
        }
        catch (err) {
            return false;
        }
    }, 

    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    },

    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    },

    logout() {
      
        return this.fetch(constants.default.baseUrl + '/api/user/logout/' + this.getClient(), {
          
            method: 'POST',
            body: {
                username: this.getUserName(),
                client: this.getClient()
            }

        }).then(res => {
            // Clear user token and profile data from localStorage
            localStorage.removeItem('id_token');
            return Promise.resolve(res);
        })
        
    },

    getProfile() {
        // Using jwt-decode npm package to decode the token
        return jwtDecode(this.getToken());
    },


    fetch(url, options) {
        // performs api calls sending the required authentication headers
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }

        // Setting Authorization header
        // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return axios({
            method: 'post',
            url: url,        
            data: options.body,
            config: { headers: { headers } }
            })
            .then(this._checkStatus)
           // .then(response => response.json())
    },

    _checkStatus(response) {

        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
            return response
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}

export default AuthService;